module.exports = __webpack_public_path__ + "static/media/online-meet.2170aa19.png";